<app-tagviewer
	(tagClicked)="onTagClicked($event)"
	(resetFilter)="resetFilter.emit()"
	[clickable]="clickable"
	[selectedTags]="selectedTags"
	[tags]="tags"
	[emptySearchResults]="emptySearchResults"
	[headerKey]="'attachments.AdditionalInfo'">
</app-tagviewer>
